import { makeStyles } from "@fluentui/react-components";

export const useManageUsersStyles = makeStyles({
  groupsText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "inline-block",
  },
});
